import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormGroup,
  ButtonGroup,
  Form,
  Card,
  CardBody,
  CustomInput,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import MultliLanguages from './MultliLanguages';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  postAPI_Update_FacebookIntegration,
  putAPI_Update_Ingetration,
  gAPI_Ingetration,
  gAPI_Property_List,
  dAPI_Delete_Ingetration,
} from '../../../../../constants/APIs';
import Select from 'react-select';
import { NavLink } from 'react-router-dom';
import Validation from '../../../../../components/Validation';
export default function PersistentMenu({ match, history }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [integrationType, setIntegrationType] = useState("");
  const [initialView, setInitialView] = useState(false);
  const [localeFields, setLocaleFields] = useState([
    {
      locale: 'default',
      callToActions: [
        {
          title: '',
          type: '',
          payLoad: '',
          url: '',
        },
      ],
    },
  ]);
  const localeOptions = [
    { id: 'en_US', name: 'en-English', direction: 'ltr' },
    { id: 'es_ES', name: 'es-Español', direction: 'ltr' },
    { id: 'zh', name: 'zh-简体中文', direction: 'ltr' },
    { id: 'fr_FR', name: 'fr-français', direction: 'ltr' },
    { id: 'zh_HK', name: 'hk-繁体中文', direction: 'ltr' },
    { id: 'mi', name: 'mi-Maori', direction: 'ltr' },
    { id: 'id_ID', name: 'id-Bahasa Indonesia', direction: 'ltr' },
    { id: 'tl_PH', name: 'tl-Tagalog (Filipino)', direction: 'ltr' },
    { id: 'vi_VN', name: 'vi-vietnamese', direction: 'ltr' },
    { id: 'ko_KR', name: 'ko-한국인', direction: 'ltr' },
  ];
  const WebsitelocaleOptions = [
    { id: "en", name: "English", desc: "English", code: "en", locale: "en" },
    { id: "hi", name: "Hindi", desc: "हिंदी", code: "hi", locale: "hi" },
    {
      id: "id",
      name: "Indonesian",
      desc: "bahasa Indonesia",
      code: "id",
      locale: "id",
    },
    { id: "it", name: "Italian", desc: "Italiano", code: "it", locale: "it" },
    { id: "es", name: "Spanish", desc: "Español", code: "es", locale: "es" },
    { id: "fr", name: "French", desc: "français", code: "fr", locale: "fr" },
    { id: "de", name: "German", desc: "Deutsche", code: "de", locale: "de" },
    { id: "zh", name: "Chinese", desc: "简体中文", code: "ZH-簡", locale: "zh" },
    {
      id: "vi",
      name: "Vietnamese",
      desc: "Tiếng Việt",
      code: "vi",
      locale: "vi",
    },
    { id: "th", name: "Thai", desc: "ไทย", code: "th", locale: "th" },
    { id: "ja", name: "Japanese", desc: "日本語", code: "ja", locale: "ja" },
    {
      id: "zh-TW",
      name: "Chinese (Traditional)",
      desc: "繁體中文",
      code: "ZH-繁",
      locale: "hk",
    },
    {
      id: "tl",
      name: "Tagalog (Filipino)",
      desc: "Tagalog (Filipino)",
      code: "tl",
      locale: "tl",
    },
    { id: "af", name: "Afrikaans", desc: "Afrikaans", code: "af", locale: "af" },
    { id: "ko", name: "Korean", desc: "한국어", code: "ko", locale: "ko" },
    { id: "mi", name: "Maori", desc: "Maori", code: "mi", locale: "mi" },
    { id: 'ar', name: 'Arabic', desc: "عربي", code: "ar", locale: "ar" },
    { id: "pt", name: "Portuguese", desc: "Português", code: "pt", locale: "pt" },
    { id: 'ru', name: 'Russian', desc: "Русский", code: "ru", locale: "ru" },
    { id: 'km', name: 'Cambodian', desc: "ខ្មែរ", code: "km", locale: "km" },

  ];
  const [inputData, setInputData] = useState({});
  const [selectLang, setSelectLang] = useState('');
  const [isShowLangPop, setShowLangPop] = useState(false);
  const [isShowDeletePop, setShowDeletePop] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState("");

  const [changeLanguageField, setChangeLanguageField] = useState([
    {
      title: 'Switch Language',
      type: 'postback',
      payLoad: 'switch_language',
    },
  ]);
  const [allLocale, setAllLocale] = useState([]);
  const integrationId = match.params.id;
  useEffect(() => {
    LoadData();
  }, [integrationId]);
  const LoadData = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        console.log(res.data);
        setIntegrationType(res.data.channel);
        if (res.data.channel === "WebsiteDirectLine") {
          const modelNudges = res.data.channelDetails.initiationRuleset[0].nudges.map((nudge) => {
            if (nudge.eyeCatcher && nudge.greeting) {
              return {
                eyeCatcher: {
                  code: nudge.eyeCatcher.query.code,
                  filterTags: null,
                },
                greeting: {
                  code: nudge.greeting.query.code,
                  filterTags: null,
                },
                delayInMilliseconds: nudge.delayInMilliseconds,
                delayInMillisecondsInMobile: nudge.delayInMillisecondsInMobile,
                disabledInDesktop: nudge.disabledInDesktop,
                disabledInMobile: nudge.disabledInMobile,
                buttons: nudge.buttons,
              };
            }
          });
          if (res.data.channelDetails.persistentMenu.length > 0) {
            setLocaleFields(res.data.channelDetails.persistentMenu);
            setInitialView(true);
          }
          setInputData({
            ...inputData,
            name: res.data.name,
            level: res.data.level,
            properties: [...res.data.properties],
            sessionTimeoutInSeconds: res.data.sessionTimeoutInSeconds,
            baseUrl: res.data.channelDetails.baseUrl,
            homePageRoute: res.data.channelDetails.homePageRoute,
            defaultLanguage: 'en-US',
            defaultRuleDescription: 'Default',
            defaultRuleNudges: [...modelNudges],
            menuEnabled: res.data.channelDetails.menuEnabled,
            persistentMenu: res.data.channelDetails.persistentMenu,
            botSettings: { ...res.data.botSettings },
            liveChatSetting: res.data.liveChat,
            engagementRules: [...res.data.engagementRules]
          });
          let allLocales = WebsitelocaleOptions.filter((itemA) => {
            return !res.data.channelDetails.persistentMenu.find((itemB) => {
              return itemA.locale === itemB.locale;
            })
          })
          setAllLocale(allLocales);
        }
        else {
          if (res.data.channelDetails.persistentMenu.length > 0) {
            setLocaleFields(res.data.channelDetails.persistentMenu);
            setInitialView(true);
          }
          let Bot = {};
          console.log(res.data.botSettings);
          if (res.data.botSettings !== null) {
            Bot = {
              Name: res.data.botSettings.name,
              Tagline: res.data.botSettings.Tagline,
              Colours: res.data.botSettings.colours,
              Text: res.data.botSettings.text,
              Urls: res.data.botSettings.urls,
              Multilingual: res.data.botSettings.multilingual,
              DefaultLanguage: res.data.botSettings.defaultLanguage,
              Languages: res.data.botSettings.languages,
            };
          } else {
            Bot = {
              Name: 'Facebook Bob',
              Tagline: '',
              Colours: '',
              Text: '',
              Urls: '',
              Multilingual: false,
              DefaultLanguage: 'en',
              Languages: [],
            };
          }
          setInputData({
            ...inputData,
            Name: res.data.name,
            groupId: res.data.groupId,
            integrationId: integrationId,
            propertyId: res.data.properties[0],
            accessToken: res.data.channelDetails.accessToken,
            pageId: res.data.channelDetails.pageId,
            pageToken: res.data.channelDetails.pageToken,
            pageName: res.data.channelDetails.pageName,
            userEmail: res.data.channelDetails.userEmail,
            facebookId: res.data.channelDetails.facebookId,
            facebookName: res.data.channelDetails.facebookName,
            menuEnabled: res.data.channelDetails.menuEnabled,
            persistentMenu: res.data.channelDetails.persistentMenu,
            botSettings: Bot,
            liveChatSetting: res.data.liveChat,
          });
          let allLocales = localeOptions.filter((itemA) => {
            return !res.data.channelDetails.persistentMenu.find((itemB) => {
              return itemA.id === itemB.locale;
            })
          })
          setAllLocale(allLocales);
        }

      })
      .catch((err) => console.log('err', err));
  };

  const handleDefaultInputChange = (index, itemIndex, event) => {
    const values = [...localeFields];
    if (event.target.name === 'type') {
      if (event.target.value === 'postback') {
        values[index].callToActions[itemIndex].type = event.target.value;
      } else {
        values[index].callToActions[itemIndex].type = event.target.value;
      }
    } else if (event.target.name === 'title') {
      values[index].callToActions[itemIndex].title = event.target.value;
    } else if (event.target.name === 'payload') {
      values[index].callToActions[itemIndex].payLoad = event.target.value;
    } else if (event.target.name === 'url') {
      values[index].callToActions[itemIndex].url = event.target.value;
    }
    setLocaleFields(values);
    setInputData({ ...inputData, persistentMenu: values });
  };
  const handleAddDefaultFields = (index) => {
    console.log(localeFields, index, inputData);
    const values = [...localeFields];
    values[index].callToActions.push({
      title: '',
      type: '',
      payLoad: '',
      url: '',
    });
    setLocaleFields(values);
    setInputData({ ...inputData, persistentMenu: values });
  };
  const handleRemoveDefaultFields = (index, itemindex) => {
    const values = [...localeFields];
    values[index].callToActions.splice(itemindex, 1);
    setLocaleFields(values);
    setInputData({ ...inputData, persistentMenu: values });
  };
  const handleLocaleChange = (e) => {
    setSelectLang(e.target.value);
  };
  const handleCopy = (index) => {
    const values = [...localeFields];
    let copydata = [];
    values[index].callToActions.map((item, index) => {
      copydata.push({
        title: item.title,
        type: item.type,
        payLoad: item.payLoad,
        url: item.url,
      });
    });
    values.push({
      locale: selectLang,
      callToActions: copydata,
    });
    setLocaleFields(values);
    setInputData({ ...inputData, persistentMenu: values });
    setShowLangPop(!isShowLangPop);
  };
  const handleSubmit = () => {
    if (integrationType === "WebsiteDirectLine") {
      let MenuData = [];
      localeFields.map((item, index) => {
        let MenuDataItem = [];
        item.callToActions.map((menu) => {
          MenuDataItem.push({
            type: menu.type,
            title: menu.title,
            payLoad: menu.payLoad,
            url: menu.url,
          });
        });
        MenuData.push({
          locale: item.locale,
          callToActions: MenuDataItem,
        });
        console.log(MenuDataItem);
      });
      let websiteModel = {
        ...inputData,
        persistentMenu: MenuData
      }
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
        data: websiteModel,
      })
        .catch((err) => console.error(err))
        .then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            LoadData();
            NotificationManager.success(
              '',
              'Menu updated successfully',
              3000,
              null,
              null,
              'success'
            );
          }
        });
    }
    else {
      let MenuData = [];
      localeFields.map((item, index) => {
        let MenuDataItem = [];
        item.callToActions.map((menu) => {
          if (menu.type === 'postback') {
            MenuDataItem.push({
              type: menu.type,
              title: menu.title,
              payload: menu.payLoad,
            });
          } else if (menu.type === 'web_url') {
            MenuDataItem.push({
              type: menu.type,
              title: menu.title,
              url: menu.url,
              webview_height_ratio: 'full',
            });
          }
        });
        if (inputData.botSettings.Multilingual) {
          changeLanguageField.map((chanLang) => {
            MenuDataItem.push({
              type: chanLang.type,
              title: chanLang.title,
              payload: chanLang.payLoad,
            });
          });
        }

        MenuData.push({
          locale: item.locale,
          composer_input_disabled: false,
          call_to_actions: MenuDataItem,
        });
      });
      AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_FacebookIntegration}/${integrationId}?group_id=${getGroupID()}`,
        data: inputData,
      }).then(() => {
        if (inputData.menuEnabled === true) {
          let data = {
            persistent_menu: MenuData,
          };
          let getWelcome = {
            get_started: {
              payload: 'Welcome',
            },
          };
          AxiosAPI({
            method: 'POST',
            url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${inputData.pageToken}`,
            data: getWelcome,
          }).then((res) => {
            console.log(res);
            if (res.data.result === 'success') {
              AxiosAPI({
                method: 'POST',
                url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${inputData.pageToken}`,
                data: data,
              }).then((perMenu) => {
                console.log(perMenu.data);
                LoadData();
                NotificationManager.success(
                  '',
                  'Menu updated successfully',
                  3000,
                  null,
                  null,
                  'success'
                );
              });
            }
          });
        }
        else {
          let data = {
            fields: ["persistent_menu"]
          };
          console.log(data);
          let getWelcome = {
            get_started: {
              payload: 'Welcome',
            },
          };
          AxiosAPI({
            method: 'POST',
            url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${inputData.pageToken}`,
            data: getWelcome,
          }).then((res) => {
            console.log(res);
            if (res.data.result === 'success') {
              AxiosAPI({
                method: 'DELETE',
                url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${inputData.pageToken}`,
                data: data,
              }).then((perMenu) => {
                console.log(perMenu.data);
                LoadData();
                NotificationManager.success(
                  '',
                  'Menu updated successfully',
                  3000,
                  null,
                  null,
                  'success'
                );
              });
            }
          });
        }
      });
    }

  };
  const RedirectToIntegration = () => {
    if (integrationType === "WebsiteDirectLine") {
      history.push('/app/pages/integrationdetail/' + integrationId);
    }
    else {
      history.push('/app/pages/facebookdetail/' + integrationId);
    }
  };
  const toggle = () => {
    setShowLangPop(!isShowLangPop);
  };
  const handleDeleteLocale = (index, event) => {
    if (index === 0) {
      setInputData({ ...inputData, persistentMenu: [] });
      setDeleteMsg("all languages specific menus will be also deleted");
      setShowDeletePop(!isShowDeletePop);
    }
    else {
      const values = [...localeFields];
      values.splice(index, 1);
      setLocaleFields(values);
      setInputData({ ...inputData, persistentMenu: values });
    }
  };
  const generateLanguagePopup = () => {
    return (
      <Fragment>
        <Modal isOpen={isShowLangPop} toggle={toggle}>
          <ModalBody>
            <Row className="mb-4">
              <Colxx xxs="12">
                <div className="text-center">
                  <h6>Select Language</h6>
                  <Separator className="mb-3" />
                  <Form>
                    <FormGroup>
                      <Input
                        type="select"
                        name="language"
                        onChange={(e) => handleLocaleChange(e)}
                      >
                        <option value={0}>Select Language</option>
                        {allLocale.map((elem, index) => {
                          return (
                            <option key={index} value={integrationType === "WebsiteDirectLine" ? elem.locale : elem.id}>
                              {elem?.name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Form>
                  <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                    <Button
                      color="primary"
                      size="xs"
                      onClick={() => handleCopy(0)}
                    >
                      Select
                    </Button>
                    <Button size="xs" color="dark" outline onClick={toggle}>
                      Cancel
                    </Button>
                  </ButtonGroup>
                </div>
              </Colxx>
            </Row>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  };
  const handleCheckChange = (e) => {
    const value = e.target.checked;
    setInputData({
      ...inputData,
      [e.target.name]: value,
    });
  };
  const toggleDelete = () => {
    setShowDeletePop(!isShowDeletePop);
  };
  const handleDeleteAllLocale = () => {
    setInputData({ ...inputData, persistentMenu: [] });
    setDeleteMsg("This will be delete persistent menu.");
    setShowDeletePop(!isShowDeletePop);
  };
  const HandleDeletePersistentMenu = () => {
    if (integrationType === "WebsiteDirectLine") {
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
        data: inputData,
      })
        .catch((err) => console.error(err))
        .then((res) => {
          setTimeout(() => {
            window.location.reload();
          }, 2000)
        });
    }
    else {
      AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_FacebookIntegration}/${integrationId}?group_id=${getGroupID()}`,
        data: inputData,
      }).then(() => {
        let data = {
          fields: ["persistent_menu"]
        };
        console.log(data);
        let getWelcome = {
          get_started: {
            payload: 'Welcome',
          },
        };
        AxiosAPI({
          method: 'POST',
          url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${inputData.pageToken}`,
          data: getWelcome,
        }).then((res) => {
          console.log(res);
          if (res.data.result === 'success') {
            AxiosAPI({
              method: 'DELETE',
              url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${inputData.pageToken}`,
              data: data,
            }).then((perMenu) => {
              console.log(perMenu.data);
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            });
          }
        });
      });
    }
  };
  const generateDeletePopup = () => {
    return (
      <Fragment>
        <Modal isOpen={isShowDeletePop} toggle={toggleDelete}>
          <ModalHeader toggle={toggleDelete}>
            <span role="img" aria-label="warning">
              ⚠️
            </span>
            {deleteMsg}
          </ModalHeader>
          <ModalBody>
            <Button
              color="danger"
              onClick={() => HandleDeletePersistentMenu()}
              size="xs"
            >
              Delete
            </Button>
            <Button
              className="ml-2"
              color="dark"
              outline
              size="xs"
              onClick={toggleDelete}
            >
              Cancel
            </Button>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  };
  return (
    <Fragment>
      <Row>
        <Colxx md="12" sm="12" lg="12" xxs="12">
          <NavLink
            to={{ pathname: integrationType === "WebsiteDirectLine" ? '/app/pages/integrationdetail/' + integrationId : '/app/pages/facebookdetail/' + integrationId }}
          >
            <h1 className="iconsminds-back" />
          </NavLink>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12" md="12" sm="12" lg="12" className="mb-4">
          <Card>
            <CardBody>
              <Row>
                <Colxx sm={12}>
                  <div className="mb-1" style={{ display: "flex" }}>
                    <CustomInput
                      id="lan"
                      type="checkbox"
                      checked={inputData.menuEnabled}
                      name="menuEnabled"
                      onChange={handleCheckChange}
                    /> <b>Enable</b>
                  </div>
                  <Separator className="mb-3" />
                </Colxx>
              </Row>
              {localeFields.map((items, index) => (
                <Row>
                  <Colxx sm={12}>
                    <Row>
                      <Colxx sm={6} className="mb-3">
                        <Label>
                          <b>
                            {items.locale === 'default' ? 'Default' :
                              integrationType === "WebsiteDirectLine" ?
                                WebsitelocaleOptions.filter((i) => i.locale.includes(items.locale)).map((item) => item.name) + ' (' + items.locale + ')'
                                :
                                localeOptions.filter((i) => i.id.includes(items.locale)).map((item) => item.name) + ' (' + items.locale + ')'
                            }
                          </b>
                        </Label>
                        {localeFields.length > 1 && (
                          <Button
                            size="xs"
                            color="danger"
                            outline
                            style={{ marginLeft: '10px', display: 'inline-block' }}
                            onClick={(event) =>
                              handleDeleteLocale(index, event)}
                          >
                            Delete
                          </Button>
                        )}
                      </Colxx>
                      {initialView && index === 0 && (
                        <Colxx sm={6}>
                          <Row>
                            <Colxx sm={6}>
                              <Button
                                onClick={toggle}
                                color="primary"
                                size="xs"
                                style={{ margin: '6px' }}
                              >
                                Copy Default Language Menu
                              </Button>
                            </Colxx>
                          </Row>
                        </Colxx>
                      )}
                    </Row>
                    {items.callToActions.map((val, i) => (
                      <Fragment>
                        <Row>
                          <Colxx sm={3} className="mb-3">
                            <Label>Title</Label>
                            <Input
                              type="text"
                              name="title"
                              value={val.title}
                              onChange={(event) =>
                                handleDefaultInputChange(index, i, event)
                              }
                            ></Input>
                          </Colxx>
                          <Colxx sm={3} className="mb-3">
                            <Label>Type</Label>
                            <Input
                              type="select"
                              name="type"
                              value={val.type}
                              onChange={(event) =>
                                handleDefaultInputChange(index, i, event)
                              }
                            >
                              <option value="0">Select Type</option>
                              <option value="web_url">Open a Link</option>
                              <option value="postback">Send to Chatbot</option>
                            </Input>
                          </Colxx>
                          {val.type === 'postback' && (
                            <Colxx sm={3} className="mb-3">
                              <Label>Pay Load</Label>
                              <Input
                                type="text"
                                name="payload"
                                defaultValue={val.payLoad}
                                onChange={(event) =>
                                  handleDefaultInputChange(index, i, event)
                                }
                              ></Input>
                            </Colxx>
                          )}
                          {val.type === 'web_url' && (
                            <Colxx sm={3} className="mb-3">
                              <Label>URL</Label>
                              <Input
                                type="text"
                                name="url"
                                defaultValue={val.url}
                                onChange={(event) =>
                                  handleDefaultInputChange(index, i, event)
                                }
                              ></Input>
                            </Colxx>
                          )}
                          <Colxx sm={3} className="mt-4">
                            <Button
                              onClick={() =>
                                handleRemoveDefaultFields(index, i)
                              }
                              color="secondary"
                              size="xs"
                              outline
                              style={{ margin: '6px' }}
                            >
                              -
                            </Button>
                          </Colxx>
                        </Row>
                      </Fragment>
                    ))}
                    {/* {inputData.botSettings.Multilingual &&
                                            <Fragment>
                                                {changeLanguageField.map((lang, i) => (
                                                    <Row>
                                                        <Colxx sm={3} className="mb-3">
                                                            <Label>Title</Label>
                                                            <Input
                                                                type="text"
                                                                name="title"
                                                                defaultValue={lang.title}
                                                                disabled={true}
                                                            ></Input>
                                                        </Colxx>
                                                        <Colxx sm={3} className="mb-3">
                                                            <Label>Type</Label>
                                                            <Input type="select" name="type" value={lang.type}
                                                                disabled={true}>
                                                                <option value="0">Select Type</option>
                                                                <option value="web_url">Open a Link</option>
                                                                <option value="postback">Send to Chatbot</option>
                                                            </Input>
                                                        </Colxx>
                                                        <Colxx sm={3} className="mb-3">
                                                            <Label>Pay Load</Label>
                                                            <Input type="text" name="payload" defaultValue={lang.payLoad}
                                                                disabled={true}></Input>
                                                        </Colxx>
                                                    </Row>
                                                ))}
                                            </Fragment>
                                        } */}

                    <Row>
                      <Colxx sm={2} className="mt-4">
                        {items.callToActions.length < 20 && (
                          <Button
                            onClick={() => handleAddDefaultFields(index)}
                            color="primary"
                            size="xs"
                            outline
                            style={{ margin: '6px' }}
                          >
                            + Add Menu
                          </Button>
                        )}
                      </Colxx>
                    </Row>
                    <Separator className="mb-5" />
                  </Colxx>
                </Row>
              ))}
              <Button color="primary" onClick={handleSubmit}>
                Update
              </Button>
              <Button
                color="secondary"
                className="ml-2"
                onClick={RedirectToIntegration}
              >
                Cancel
              </Button>
              <Button
                className="ml-2"
                color="danger"
                onClick={handleDeleteAllLocale}
              >
                Delete Persistent Menu
              </Button>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
      {generateLanguagePopup()}
      {generateDeletePopup()}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
